import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Toaster } from "@/components/ui/toaster";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AppLayoutProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
}

export function AppLayout({ isMobileMenuOpen, setIsMobileMenuOpen }: AppLayoutProps) {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-background">
      {/* Mobile sidebar backdrop */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/20 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
      
      {/* Sidebar - hidden on mobile, shown when menu button is clicked */}
      <div 
        className={cn(
          "fixed inset-y-0 left-0 z-50 lg:relative lg:z-0 transform transition-transform duration-200 ease-in-out",
          "lg:transform-none lg:flex-shrink-0",
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <Sidebar onCloseMobile={() => setIsMobileMenuOpen(false)} />
      </div>
      
      {/* Main content area - centered on tablet and desktop */}
      <main className="flex-1 overflow-y-auto w-full flex flex-col items-center">
        {/* Mobile header with menu toggle button */}
        <div className="sticky top-0 z-10 flex items-center h-14 px-4 border-b bg-card lg:hidden w-full">
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </Button>
          
          <div className="flex-1 flex justify-center">
            <span className="font-bold text-lg">Standup Hiro</span>
          </div>
          
          <div className="w-10">
            {/* Placeholder to center the logo */}
          </div>
        </div>
        
        {/* Content container - centered with max width */}
        <div className="w-full max-w-6xl px-4 sm:px-6 py-4 sm:py-6 md:py-8 mx-auto">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
}